var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#FF5A00",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6938,68.3779297v-7.8730278c1.5240002-6.9414024,8.3808994-13.2910004,16.3383999-20.2324028 c3.9790001-3.4706993,8.296402-7.7891006,8.296402-13.5449982c0-5.1640015-3.3862-9.4814014-9.9048004-9.4814014 c-5.2485008,0-8.8886013,3.8091011-10.3281021,5.4180012l-6.2642002-8.296401 c5.7564011-4.9946995,11.089901-7.3652997,19.1319027-7.3652997c10.4974976,0,20.402298,6.0953002,20.402298,18.2856998 c0,10.2431011-6.5185013,15.0683002-13.7142982,21.5869007c-3.0479012,2.7938995-9.0581017,8.0429993-9.8203011,11.5136986 H58.466301v9.9892311H19.6938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5117035,68.3779297h-13.630806c0-7.8730278,2.1171036-12.9521294,7.3652039-22.6875305l14.5615005-27.0897999 H60.7705002V8.6107998h41.8192978v9.7354012C89.4688034,41.1190987,81.5117035,58.9813995,81.5117035,68.3779297z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine27);
export default __webpack_public_path__ + "static/media/line-27.29d98d9d9a7034933f7e70b24c1463e4.svg";
export { ForwardRef as ReactComponent };